<ng-container *ngIf="restricted">Restricted</ng-container>
<div class="chart-loader" *ngIf="runningQuery">
    <fui-ellipsis-loader ></fui-ellipsis-loader>
</div>
<bi-chart (added)="add()"
          (memberSelection)="memberSelected($event)"
          (onDrop)="itemDropped($event)"
          (removed)="remove()"
          [enableDrillDown]="canDrillDown"
          [enableDrillUp]="canDrillUp"
          (drillDown)="drillDownLevel()"
          (drillUp)="drillUpLevel()"
          [title]="chartDef?.title"
          [xAxisLabel]="xAxisLabel"
          [chartType]="chartDef?.chartType"
          [selectedRefLine]="chartDef?.selectedRefLine"
          [childHierarchies]="childHierarchies"
          [height]="height"
          [seriesData]="seriesData"
          [showActions]="showActions">
</bi-chart>
